import { z } from 'zod'

// Every registry stores its images in eu-central-1 (Nuremberg); there is no
// placement choice, so the enable request only ever names that one.
export const RegistryRegion = z.literal('eu-central-1')
export type RegistryRegion = z.infer<typeof RegistryRegion>

export const RegistryStatus = z.enum(['active', 'suspended', 'deactivated', 'quota_exceeded'])
export type RegistryStatus = z.infer<typeof RegistryStatus>

export const RegistryConfig = z.object({
  enabled: z.boolean(),
  status: RegistryStatus.optional(),
  slug: z.string().optional(),
  storage_quota_bytes: z.number().optional(),
  created_at: z.string().optional()
})
export type RegistryConfig = z.infer<typeof RegistryConfig>

export const RegistryEnableRequest = z.object({
  region: RegistryRegion.optional()
})
export type RegistryEnableRequest = z.infer<typeof RegistryEnableRequest>

export const RegistrySlugRequest = z.object({
  slug: z.string().min(3).max(40).regex(/^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/)
})
export type RegistrySlugRequest = z.infer<typeof RegistrySlugRequest>
